<!--
Copyright (c) 2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<footer class="common-footer">
    <nav class="footer-links" aria-label="NVIDIA footer links">
        @for (link of footerLinks; track link.href) {
            <a class="font-body2-link footer-link" [href]="link.href" target="_blank" rel="noopener noreferrer">
                {{ link.labelKey | translate }}
            </a>
        }
    </nav>
</footer>
